'use strict';
const API = require('services/api');
const apiURLBuilder = require('core/apiURLBuilder');
//const Storage = require('utilities/storage');
//const { /*logApiError, */ formatMessage } = require('utilities/apiErrorLogger');
//const { logoutAlert } = require('actions/logout');
//const get = require('lodash/object/get');
//const set = require('lodash/object/set');
//const BrowserUtils = require('./browserUtils');
//const { cookiesDomain } = require('core/environmentConfig');
const { getDispatch } = require('core/storeHelper'); // Access to the Store dispatch
//const notification = require('actions/notifications');
//const { isDisasterRecoveryMode } = require('utilities/contactCenter/disasterRecoveryhelper');
//const usd = require('utilities/usd');
/*const request = require('superagent');

const defaultParams = {
    header: {},
    query: {}
};

function get(url, params = defaultParams) {
    params.header.accept = params.header.accept || 'application/json';
    let finalRequest = request
        .get(url)
        .timeout(60000)
        .query(params.query)
        .set('Accept', params.header.accept);
    if (params.header.responseType) {
        finalRequest = finalRequest.responseType(params.header.responseType);
        delete params.header.responseType;
    }
    return finalRequest.set(params.header);    
}*/

const serviceCall = function({
    service,
    endpoint,
    params = {},
    url = apiURLBuilder.getURL(endpoint, params),
    contentType,
    method,
}) {
    const parsedUrl = url.replace('http://', 'https://').replace(':80', '');
    return service(parsedUrl, params, contentType, method)
        .then(response => {
            // If response is a file, we return the complete response
            if (
                response.type === 'application/pdf' ||
                response.type === 'application/vnd.ms-excel' ||
                response.type === 'text/xml' ||
                response.type === 'application/zip' ||
                response.type === 'application/octet-stream'
            ) {
                return response;
            } else {
                return response.body;
            }
        })
        .catch(error => {
            if (error instanceof Error) {
                //development errors
                throw {
                    exception: error,
                    error: {
                        description: error.name,
                    },
                    body: {
                        errorDescription: error.name, //required by standard
                        error: error.name, //required by API logger
                    },
                    text: error.name, //required by some other code
                };
            }
            //fallback to raw API errors
            throw error.response || error;
        });
};

const APIGet = function(dispatchOrConfig, url, params = {}) {
    let config;
    if (dispatchOrConfig == null) {
        config = {};
        config.dispatch = getDispatch();
        config.url = url;
        config.params = params;
    } else if (typeof dispatchOrConfig === 'function') {
        config = {};
        config.dispatch = dispatchOrConfig;
        config.url = url;
        config.params = params;
    } else {
        config = dispatchOrConfig;
    }
    config.service = API.get;

    return serviceCall(config);
};

module.exports = {
    APIGet,
};
